const accountInfoData = (state = {}, action: any) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default accountInfoData;
